"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _components = require("components");

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _actions = require("../../EpicMigration/actions");

var epicMigrationActions = _interopRequireWildcard(_actions);

var _LegacyAuth = require("./LegacyAuth.scss");

var _LegacyAuth2 = _interopRequireDefault(_LegacyAuth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegacyAuth = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}, (0, _extends3.default)({}, epicMigrationActions)), _dec(_class = function (_Component) {
  (0, _inherits3.default)(LegacyAuth, _Component);

  function LegacyAuth(props) {
    (0, _classCallCheck3.default)(this, LegacyAuth);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LegacyAuth.__proto__ || (0, _getPrototypeOf2.default)(LegacyAuth)).call(this, props));

    _this.state = {
      isProcessing: false
    };
    return _this;
  }

  (0, _createClass3.default)(LegacyAuth, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          location = _props.location,
          recallIfWeRedirectedToEpicLoginAndCompleteLoginIfSo = _props.recallIfWeRedirectedToEpicLoginAndCompleteLoginIfSo;


      console.log("LegacyAuth: componentDidMount, query:", location.query);

      // Check if we have a code parameter for Epic OAuth
      if (location.query && location.query.code) {
        console.log("LegacyAuth: Processing Epic OAuth code");
        this.setState({ isProcessing: true });

        // Directly call the Epic login completion handler
        // This prevents the App defer hook from interfering
        var result = recallIfWeRedirectedToEpicLoginAndCompleteLoginIfSo(location);

        // Ensure we have a promise to work with
        _promise2.default.resolve(result).then(function () {
          console.log("LegacyAuth: Epic login completed successfully");
          // Wait a bit to ensure all requests complete
          setTimeout(function () {
            window.location.href = "/";
          }, 1000);
        }).catch(function (err) {
          console.error("LegacyAuth: Error during Epic login:", err);
          // Redirect anyway on error
          window.location.href = "/";
        });
      } else {
        // No code parameter, redirect immediately
        console.log("LegacyAuth: No code parameter found, redirecting");
        window.location.href = "/";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "- Authenticating",
          documentDescription: "Completing authentication..."
        },
        _react2.default.createElement(
          "div",
          { className: _LegacyAuth2.default.overlay },
          _react2.default.createElement(
            "div",
            { className: _LegacyAuth2.default.wrap },
            _react2.default.createElement(
              "div",
              { className: _LegacyAuth2.default.preloader },
              _react2.default.createElement(_Preloader2.default, null)
            ),
            _react2.default.createElement(
              "span",
              { className: _LegacyAuth2.default.label },
              "Authenticating..."
            )
          )
        )
      );
    }
  }]);
  return LegacyAuth;
}(_react.Component)) || _class);
exports.default = LegacyAuth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/LegacyAuth/LegacyAuth.jsx
// module id = 2938
// module chunks = 0